//Crisis GameMode
export const OneStationUnknownPeers = "OneStationUnknownPeers";
export const OneStationKnownPeers = "OneStationKnownPeers";
export const AllStationsKnownPeers = "AllStationsKnownPeers";

export const minTimeBeforeSimulationStartsInMiliseconds = 1800000; //30 min
export const minSimulationDurationInMiliseconds = 21600000; //6 hours
export const maxSimulationDurationInMiliseconds = 187200000; //52 hours
